import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

interface NavItem {
  label: string;
  path: string;
  badge?: string;
  exact?: boolean;
}

export const useNav = (): NavItem[] => {
  const { pathname } = useLocation();
  const teamSlug = pathname.split("/")[1] || "";

  const nav = useMemo(() => {
    const prefix = `/${teamSlug}`;

    // Early Moments has the original nav with vision sub-nav
    if (teamSlug === "early-moments") {
      if (pathname.startsWith(`${prefix}/vision`)) {
        return [
          { label: "Create", path: `${prefix}/vision/plan` },
          { label: "Track progress", path: `${prefix}/vision/timeline` },
        ];
      }

      return [
        { label: "Coach's notes", path: `${prefix}/coachs-notes`, badge: "BETA" },
        { label: "Funnel", path: `${prefix}/funnel` },
        { label: "Conversion", path: `${prefix}/conversion` },
        { label: "Imagery", path: `${prefix}/imagery` },
        { label: "Statements", path: `${prefix}/statements` },
        { label: "Category", path: `${prefix}/category` },
      ];
    }

    // All other teams get the standard nav
    return [
      { label: "Coach's notes", path: `${prefix}/coachs-notes`, badge: "BETA" },
      { label: "Funnel", path: `${prefix}/funnel` },
      { label: "Conversion", path: `${prefix}/conversion` },
      { label: "Imagery", path: `${prefix}/imagery` },
      { label: "Statements", path: `${prefix}/statements` },
      { label: "Category", path: `${prefix}/category` },
    ];
  }, [pathname, teamSlug]);

  return nav;
};
